import React from 'react'
import { Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './ContentMenu.css'

class ContentMenu extends React.Component {
	state = {
		currentTab: 0,
	}

	handleEvent = (e, idx) => {
    this.setState({ currentTab: idx });
    if(this.props.componentStateUpdate){this.props.componentStateUpdate(idx)}
	}

	render() {
		const classNames = ['Content-menu']
		let icon = 'chevron-right'

	  if(this.props.menuOnLeft) {
	    classNames.push('menu-on-left')
			icon = 'chevron-right'
	  }

		if(this.props.menuOnTop) {
	    classNames.push('menu-on-top')
			icon = ''
	  }

		if(this.props.activeHasBackground) {
	    classNames.push('activ-has-background')
	  }

		if(this.props.activeHasBorder) {
	    classNames.push('active-has-border')
	  }

		const classNamesActive = idx => `Content-menu-item ${this.state.currentTab === idx ? 'is-active' : ''}`

		return (
			<div className={classNames.join(' ')}>
				<div className="Content-menu-items">
					{this.props.tabs.map((tab, idx) => (
						<div key={idx} className={classNamesActive(idx)} >
							<a onClick={e => this.handleEvent(e, idx)}><span className="is-underlined">{tab}</span><Icon name={this.props.icon || icon} /></a>
						</div>
					))}
				</div>

				<div className="Content-menu-tabs">
					{React.Children.map(this.props.children, (child, idx) => {
						return idx === this.state.currentTab ? child : null
					})}
				</div>

			</div>
		)
	}
}

const ContentMenuTab = props => (
	<div className="Content-menu-tab">
		{props.children}
	</div>
)

export {
	ContentMenu,
	ContentMenuTab,
}
